var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-documents"},[_vm._m(0),_c('v-container',[_c('services-list',{attrs:{"data":_vm.services}})],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"d-flex justify-center align-center"},[_c('img',{attrs:{"width":"130","src":require("@/assets/vai-vem/vaivem-icon.svg")}})])
}]

export { render, staticRenderFns }